import { render, staticRenderFns } from "./TermsAndConditionsPage.de.vue?vue&type=template&id=3a69f976"
import script from "./TermsAndConditionsPage.de.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsPage.de.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports